import React, { FC, ReactNode } from "react";
import classNames from "classnames/dedupe";

import Link, { ILink } from "../../ActionsSelectors/Link/Link";

export interface IBreadcrumbItemProps extends ILink {
  /**
   * The flag to indicate if current item is last/active
   *
   * @default 'false'
   */
  active?: boolean;
  /**
   * The custom set of css classes used to style component
   *
   * root: applied to outer 'div' element
   */
  classes?: { root?: string };
  children?: ReactNode;
}

const BreadcrumbItem: FC<IBreadcrumbItemProps> = ({
  active,
  classes,
  text,
  children,
  ...other
}) => {
  const rootClasses = classNames("breadcrumb-item", classes?.root, {
    active,
  });

  return (
    <li data-testid="breadcrumb-item-component" className={rootClasses}>
      {active ? (
        text
      ) : (
        <Link
          data-testid="breadcrumb-item-link"
          text={text as string}
          {...other}
        >
          {/* eslint-disable-next-line react/jsx-no-useless-fragment */}
          {children ? <>{children}</> : null}
        </Link>
      )}
    </li>
  );
};

export default BreadcrumbItem;
